
const loadView = (view) => () => import(`../views/${view}.vue`).then(m => m.default || m);
export default [
    {
        component: loadView('cashier/action'),
        path: '/',
        name: 'home',
    },
    {
        component: loadView('cashier/dashboard'),
        path: '/dashboard',
        name: 'dashboard',
    },
    {
        component: loadView('cashier/action'),
        path: '/',
        name: 'select_type',
    },
    {
        component: loadView('auth/login'),
        path: '/login',
        name: 'login'
    },
    {
        component: loadView('cashier/restaurants'),
        path: '/restaurants',
        name: 'restaurants'
    },
    {
        component: loadView('cashier/order'),
        path: '/order',
        name: 'order'
    },
    {
        component: loadView('cashier/order_list'),
        path: '/orders-report',
        name: 'order_list'
    },
    {
        component: loadView('cashier/receivable'),
        path: '/receivable',
        name: 'receivable'
    },
    {
        component: loadView('print_template/customerbill'),
        path: '/bill-print',
        name: 'bill-print'
    },
    {
        component: loadView('cashier/pending_order'),
        path: '/pending',
        name: 'pending_order'
    },
    {
        component: loadView('cashier/choice_locations'),
        path: '/locations',
        name: 'locations'
    },
    {
        component: loadView('cashier/order_print_list_preview'),
        path: '/order-print-list-preview',
        name: 'order_print_list_preview'
    },
    {
        component: loadView('profile/change_password'),
        path: '/user/change_password',
        name: 'change_password'
    },
    {
        component: loadView('setting/printer'),
        path: '/printer-setting',
        name: 'setting_printer',
    },
    {
        component: loadView('cashier/printing_invoice'),
        path: '/printing-invoice',
        name: 'printing',
    },
    {
        component: loadView('errors/404'),
        path: '*',
        name: '404',
    },
    {
        component: loadView('cashier/cashiers'),
        path: '/cashiers',
        name: 'cashiers',
    },
];
